export default __webpack_public_path__ + "static/media/HeinekenSerif18-Medium.d8966a69.ttf";